var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          fill: "none",
          viewBox: "0 0 24 24"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#4868FD",
          d:
            "M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#FFE252",
          d:
            "M12.206 10.766a3.463 3.463 0 1 0 0-6.926 3.463 3.463 0 0 0 0 6.926ZM19.989 20.366H4.25v-1.269a6.98 6.98 0 0 1 6.995-6.994h1.748a6.98 6.98 0 0 1 6.995 6.994v1.269Z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#02016F",
          d:
            "M16.629 14.297c.034-.034.068-.034.068-.069.206-.137.617-.514.652-.617a7.235 7.235 0 0 0-.901-.603c-.446.412-.574.432-.882.775-.103.137-.274.137-.549.343-.068.034-.137.103-.24.137.069-.069-.171.034-.068-.034-.412.274-.274.205-.72.377-.857-.069-.275.274-1.337.171h.068c-.24 0-.926.103-.308.069-.446.137-1.063-.035-.138-.035-.102-.034-.342.035-.24-.034-.102.069-.89-.034-.582-.068-.172 0-.343-.069-.515-.103.343.068.069.068.206.103-.446-.035-.24-.138-.72-.24.617.205-1.166-.309-.789-.275-.617-.308-.582-.274-.822-.514-.069-.034-.412-.24-.24-.171-.103-.035-.309-.206 0-.069-.103-.069-.564-.434-.614-.526 0 0-.377.186-.514.278-.137.092-.485.37-.485.37.138.308.995.804.687.77.171 0 .823.342.343.274.068.034.137.103.274.205-.103-.24.137.035.274.172-.103-.103.309-.035.069.034a1 1 0 0 0 .308.069c-.068-.035-.034.068 0 .102-.034-.034.24.103.31.138l-.104-.069c.583.206.686.24 1.337.377-.685 0-.24.103-.411.103.651.103 1.543.206 2.331.206.48-.034 1.2-.274 1.646-.24.034-.034.069-.034.171-.069-.034-.068 1.852-.651 2.435-1.337Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }